import styled from 'styled-components';

export const StyledExpandButton = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;

  &.focus-visible {
    outline: ${p => p.theme.text.linkExternalHover} dotted 1px;
    outline: -webkit-focus-ring-color auto 1px;
  }
`;
